export interface IOption {
  id: number,
  label: string,
  disabled: boolean,
  selected: boolean
}
